// src/config/vault/tabRequirements.ts
interface TabConfig {
  idRequirementSlug: string | null; // null means no ID prerequisite
  lockedFormSlugs: string[] | null; // slugs of form requirements locked behind ID/POA chain; null means no form lock
  bdcPrerequisiteSlugs?: string[] | null;
  displayName: string;
}

export const TAB_REQUIREMENTS: Record<string, TabConfig> = {
  'tenant-pf': {
    idRequirementSlug: 'official-id',
    lockedFormSlugs: null,
    displayName: 'Documentos del Inquilino',
  },
  'tenant-pm': {
    idRequirementSlug: 'official-id',
    lockedFormSlugs: null,
    bdcPrerequisiteSlugs: ['bdc-company-data'],
    displayName: 'Documentos del Inquilino',
  },
  'tenant-pf-cja': {
    idRequirementSlug: 'official-id',
    lockedFormSlugs: null,
    displayName: 'Documentos del Inquilino',
  },
  'tenant-pm-cja': {
    idRequirementSlug: 'official-id',
    lockedFormSlugs: null,
    displayName: 'Documentos del Inquilino',
  },
  'guarantor-pf': {
    idRequirementSlug: 'official-id',
    lockedFormSlugs: null,
    displayName: 'Documentos del Fiador',
  },
  'guarantor-pf-cja': {
    idRequirementSlug: 'official-id',
    lockedFormSlugs: null,
    displayName: 'Documentos del Fiador',
  },
  'guarantor-pm': {
    idRequirementSlug: 'official-id',
    lockedFormSlugs: null,
    bdcPrerequisiteSlugs: ['bdc-company-data'],
    displayName: 'Documentos del Fiador',
  },
  'guarantor-pm-cja': {
    idRequirementSlug: 'official-id',
    lockedFormSlugs: null,
    displayName: 'Documentos del Fiador',
  },
  'guarantor-investigation-pf': {
    idRequirementSlug: 'official-id',
    lockedFormSlugs: null,
    displayName: 'Investigación del Fiador',
  },
  'guarantor-investigation-pm': {
    idRequirementSlug: 'official-id',
    lockedFormSlugs: null,
    bdcPrerequisiteSlugs: ['bdc-company-data'],
    displayName: 'Investigación del Fiador',
  },
  collateral: {
    idRequirementSlug: null, // No ID required
    lockedFormSlugs: null,
    displayName: 'Inmueble en Garantia',
  },
  'lease-contract': {
    idRequirementSlug: 'official-id',
    lockedFormSlugs: null,
    displayName: 'Contrato de Arrendamiento',
  },
  'lease-contract-pf': {
    idRequirementSlug: 'official-id',
    lockedFormSlugs: null,
    displayName: 'Contrato de Arrendamiento',
  },
  'lease-contract-pm': {
    idRequirementSlug: 'official-id',
    lockedFormSlugs: null,
    displayName: 'Contrato de Arrendamiento',
  },
  'owner-representative': {
    idRequirementSlug: 'official-id',
    lockedFormSlugs: null,
    displayName: 'Representante del Propietario',
  },
  // MB-431 templates. The landlord actor now sees these tabs in their own vault, so
  // they need the same ID prerequisite as every other identity tab: with no entry here
  // `getTabConfig` returns null and the tab silently opts out of the ID gating.
  'owner-representative-pm': {
    idRequirementSlug: 'official-id',
    lockedFormSlugs: null,
    displayName: 'Representante del Propietario',
  },
  'landlord-pf': {
    idRequirementSlug: 'official-id',
    lockedFormSlugs: null,
    displayName: 'Documentos del Propietario',
  },
  'landlord-pm': {
    idRequirementSlug: 'official-id',
    lockedFormSlugs: null,
    displayName: 'Documentos del Propietario',
  },
};

export function getTabConfig(tabSlug: string): TabConfig | null {
  return TAB_REQUIREMENTS[tabSlug] || null;
}

export function requiresIdVerification(tabSlug: string): boolean {
  const config = getTabConfig(tabSlug);
  // Return true only if config exists AND has a non-null idRequirementSlug
  return config !== null && config.idRequirementSlug !== null;
}
